var a={notificationBadge:"notificationBadge--VTUgo",danger:"danger--4KkMp",informational:"informational--GYM9L",success:"success--bbGf6",warning:"warning--CSiSP"};export{a as default};
//# sourceMappingURL=NotificationBadge.module.scss.js.map
